// ####################################################################
// #                      MAIN CSS STYLING JS FILE                    #
// ####################################################################
export function replaceSvgIcon() {
    const newSvgPath = "/media/assets/logos/SanaponteLogoApfel.svg";

    fetch(newSvgPath)
        .then((response) => response.text())
        .then((svgContent) => {
            const currentSvg = document.getElementById("icon-search");
            if (currentSvg) {
                const parser = new DOMParser();
                const newSvg = parser.parseFromString(svgContent, "image/svg+xml").documentElement;
                currentSvg.parentNode.replaceChild(newSvg, currentSvg);
                const svgElement = document.getElementById("Ebene_1");
                svgElement.style.height = "26px";
                svgElement.style.width = "26px";
            }
        })
        .catch((error) => console.error("Error fetching the new SVG:", error));
}

export function replaceSvgIconDynamic(svgPath, elementId) {
    // console.info("DYNAMIC SVG export function CALLED...");
    fetch(svgPath)
        .then((response) => response.text())
        .then((svgContent) => {
            const currentSvg = document.getElementById(elementId);
            if (currentSvg) {
                const parser = new DOMParser();
                const newSvg = parser.parseFromString(svgContent, "image/svg+xml").documentElement;
                currentSvg.parentNode.replaceChild(newSvg, currentSvg);
                const svgElement = newSvg.querySelector("svg");
                if (svgElement) {
                    svgElement.style.height = "100%";
                    svgElement.style.width = "100%";
                }
            }
        })
        .catch((error) => console.error("Error fetching the new SVG:", error));
}

// ####################################################################
// #               STYLED BUY-WIDGET LOGIC POSITIONING                #
// ####################################################################
export function setupResponsiveQuantitySelector() {

    const quantityGroup = document.querySelector('.buy-widget .input-group');
    const packageOptions = {
        '0190165d050b725ba84501c3d935fb9c': document.querySelector('.product-detail-configurator-option.option-3'), // Einzelpackung
        '0190165a688a71b89edde07263dc8071': document.querySelector('.product-detail-configurator-option.option-2'), // Fünferpackung
        '01902597a4c27e3f9f6abab48da8a8b5': document.querySelector('.product-detail-configurator-option.option-1')  // Achterpackung
    };

    if (!quantityGroup || Object.values(packageOptions).some(option => option === null)) {
        console.warn("Quantity group oder eine der package options wurde nicht gefunden.");
        return;
    }

    function placeQuantityGroup() {
        const selectedOption = document.querySelector('input[type="radio"]:checked');
        if (selectedOption) {
            const defaultValue = selectedOption.defaultValue;
            console.log("Default Value:", defaultValue);

            const option = packageOptions[defaultValue];
            if (option) {
                option.appendChild(quantityGroup);
                quantityGroup.style.display = 'flex';
            } else {
                console.warn("Keine Übereinstimmung für defaultValue:", defaultValue);
            }
        }
    }

    placeQuantityGroup();

    Object.keys(packageOptions).forEach(key => {
        const option = packageOptions[key];
        option.addEventListener('click', function () {
            // Neu platzieren der `input-group` nach Auswahl einer Option
            option.appendChild(quantityGroup);
            quantityGroup.style.display = 'flex';
        });
    });

    // Nach jedem AJAX-Reload wird `input-group` neu platziert
    document.addEventListener('ajaxComplete', placeQuantityGroup);
}

// ####################################################################
// #                  DYNAMIC FONT SIZE CALCULATIONS                  #
// ###################################################################

export function adjustProductNameFontSize(selector) {
    const element = document.querySelector(selector);
    if (element) {
        let fontSize = 50; // Startgröße
        element.style.whiteSpace = "nowrap";
        element.style.overflow = "hidden";
        element.style.fontWeight = "800"; // Standardgewicht
        element.style.textTransform = "uppercase"; // Großbuchstaben

        // Dynamische Anpassung, falls Text zu groß ist
        while (element.scrollWidth >= element.offsetWidth && fontSize > 1) {
            fontSize -= 2;
            element.style.fontSize = `${fontSize}px`;
        }
    }
}

export function adjustProductNameFontSize_headlining(selector) {
    const element = document.querySelector(selector);
    if (element) {
        let fontSize = 50; // Startgröße
        element.style.whiteSpace = "nowrap";
        element.style.overflow = "hidden";
        element.style.fontWeight = "800"; // Standardgewicht
        element.style.textTransform = "uppercase"; // Großbuchstaben
        element.style.fontSize = `${fontSize}px`; // Setze die Startgröße

        // Dynamische Anpassung, falls Text zu groß ist
        while (element.scrollWidth > element.offsetWidth && fontSize > 1) {
            fontSize -= 1;
            element.style.fontSize = `${fontSize}px`;
            console.log(`Aktuelle Schriftgröße: ${fontSize}px, Scrollbreite: ${element.scrollWidth}, Elementbreite: ${element.offsetWidth}`);
        }
        console.log(`Finale Schriftgröße: ${fontSize}px`);
    }
}

export function checkProbeArtikel() {
    const probeArtikelExists = document.querySelector('.probe-artikel') !== null;
    const option_element = document.querySelector(".option-4");
    if (probeArtikelExists) {
        console.log('Klasse probe-artikel ist vorhanden.');
        option_element.style.display = "block";
    } else {
        console.log('Klasse probe-artikel ist nicht vorhanden.');
        if (option_element) {
            option_element.style.display = "none";
        }
    }
}


// css blinking effect for highlights in form fields
const style = document.createElement("style");
style.innerHTML = `
   @keyframes blink {
     50% { opacity: 0; }
   }
   .blinking {
     animation: blink 1s step-end infinite;
   }
   `;
document.head.appendChild(style);

